import React, { useState } from 'react';

const WpForm_Faq = () => {
    const faqs = [
        {
            q: "What are WhatsApp Forms?",
            a: "Chat-native forms that open and complete inside WhatsApp. Users tap quick buttons or type short answers, upload files, give consent, and submit—all without leaving the chat."
        },
        {
            q: "How are WhatsApp Forms different from web/Google Forms links?",
            a: "No redirects or page loads. Responses happen in the same WhatsApp thread, which boosts completion rates and reduces drop-offs compared to opening an external form in a browser."
        },
        {
            q: "What kind of data can I collect?",
            a: "Names, emails, phone numbers, addresses, numeric/text inputs, single/multi-select, dates, and consent. You can also collect documents/images (e.g., ID proof, invoices) where supported."
        },
        {
            q: "Do users need to install anything or leave WhatsApp?",
            a: "No. Everything happens inside WhatsApp. Users reply with tap-to-choose buttons or short text—making it fast and familiar on any device."
        },
        {
            q: "Can WhatsApp Form submissions sync to my CRM/Sheets?",
            a: "Yes. Map fields and auto-sync submissions to CRMs, Google Sheets, or any backend via APIs/webhooks. You can also assign owners, set SLAs, and trigger workflows on submit."
        },
        {
            q: "Is approval or opt-in required to start a form?",
            a: "For business-initiated outreach, use an approved WhatsApp template. Inside an active 24-hour session, you can collect data without a template. Always follow Meta policies and obtain user consent."
        },
        {
            q: "Can I add validation, logic, prefill, or multiple languages?",
            a: "Yes. Add field validation, branching logic, and prefill known info from your CRM. Build multilingual flows so users see the form in their preferred language."
        },
        {
            q: "Do I get analytics and error handling?",
            a: "You can track starts, completes, drop-offs, and per-question conversions. Configure retries/follow-ups for non-responders and view submission logs for auditing."
        }
    ];

    const [openIndex, setOpenIndex] = useState(0); // first open by default

    const toggle = (i) => setOpenIndex((prev) => (prev === i ? -1 : i));

    return (
        <section
            className="py-5 position-relative mb-5"
            style={{
                overflow: 'hidden',
                marginTop: "70px"
            }}
        >
            {/* Styles for FAQ UI */}
            <style>{`
              .faq-card {
             background: linear-gradient(135deg, #dce7fa, #fefefe);
            border: 1px solid #dae6fc;
            border-radius: 12px;
            padding: 18px 20px;
            display: flex;
            justify-content: space-between;
           align-items: flex-start;
           gap: 16px;
           transition: box-shadow 220ms ease, transform 220ms ease, background 220ms ease;
           cursor: pointer;
           }
   
           .faq-q {
             margin: 0;
             font-family: Lato;
             font-size: 20px;
             font-weight: 600;
             color: #242121ff;
             line-height: 1.3;
           }
           .faq-a {
             margin: 8px 0 0 0;
             font-family: Lato;
             font-weight: 400;
             font-size: 1.12rem;
             color: #413e3eff;
             line-height: 1.2;
             overflow: hidden;
             max-height: 0;
             opacity: 0;
             transition: max-height 320ms ease, opacity 240ms ease, margin 240ms ease;
           }
           .faq-a.open {
             max-height: 220px; /* large enough for content */
             opacity: 1;
             margin-top: 10px;
           }
   
           /* Right circular arrow button (3D-ish) */
           
           .arrow-btn {
            flex: 0 0 auto;
            width: 26px;
            height: 26px;
            border-radius: 999px;
            display: grid;
            place-items: center;
            border: 2px solid #3b5c92; 
            background: radial-gradient(
               120% 120% at 30% 20%,
               #ffffff 0%,
               #f8faff 60%,   
               #edf3fa 100%  
           );
           box-shadow:
           inset 0 -2px 0 rgba(0, 0, 0, 0.05), 
           inset 0 1px 0 rgba(255, 255, 255, 0.8);
           transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
           }
   
           .arrow-icon {
             width: 16px;
             height: 16px;
             fill: #0F2B54; /* navy */
             transition: transform 220ms ease;
           }
           .arrow-rotated {
             transform: rotate(180deg); /* down ↔ up */
           }
   
           /* spacing between cards */
           .faq-gap { height: 16px; }
         `}</style>

            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative mb-5"
                style={{ maxWidth: '74%', zIndex: 1 }}
            >
                {/* Heading */}
                <div className="mb-5">
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Frequently ask questions
                    </h2>
                    <p
                        className="mt-2"
                        style={{
                            marginTop: -2,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.2,
                        }}
                    >
                        Quick answers on <span style={{ color: "#054E91", fontWeight: 700 }}>Vertex</span>{" "}
                        <span
                            style={{
                                background: "linear-gradient(90deg, #1F88E5 0%, #6EC9FF 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                display: "inline-block",
                                fontWeight: 700
                            }}
                        >
                            Suite's
                        </span> automation, templates, pricing and uses- so you can start fast.
                    </p>
                </div>

                {/* FAQ list */}
                <div>
                    {faqs.map((item, i) => {
                        const isOpen = openIndex === i;
                        return (
                            <div key={i}>
                                <div
                                    className="faq-card"
                                    onClick={() => toggle(i)}
                                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggle(i)}
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={isOpen}
                                >
                                    <div style={{ flex: 1 }}>
                                        <h5 className="faq-q">{item.q}</h5>
                                        <p className={`faq-a ${isOpen ? 'open' : ''}`}>{item.a}</p>
                                    </div>

                                    {/* Right circular arrow */}
                                    <div
                                        className="arrow-btn"
                                        aria-hidden="true"
                                    >
                                        {/* Down arrow SVG that rotates to up when open (gives the “3D” pop with shadows above) */}
                                        <svg
                                            viewBox="0 0 24 24"
                                            className={`arrow-icon ${isOpen ? 'arrow-rotated' : ''}`}
                                        >
                                            {/* simple chevron/triangle mix for a crisp “straight bottom arrow” look */}
                                            <path d="M12 16c-.3 0-.6-.1-.8-.3l-6-6a1.1 1.1 0 0 1 1.6-1.6L12 13.7l5.2-5.6a1.1 1.1 0 1 1 1.6 1.6l-6 6c-.2.2-.5.3-.8.3z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* gap between cards */}
                                {i !== faqs.length - 1 && <div className="faq-gap" />}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
export default WpForm_Faq